import {
  ALL_SELECT_LABEL,
  ALL_SELECT_VALUE_STRING,
} from '../../../../utils/constants/global-constants'
import {
  getDropDownOptions,
  getLookupValueDropDownOption,
} from '../../drop-downs/drop-downs'

function getInquiryOptions(list) {
  const organizationOptions = getDropDownOptions(
    list,
    ALL_SELECT_LABEL,
    ALL_SELECT_VALUE_STRING,
    'Organization',
    'Organization'
  )
  const priorityOptions = getDropDownOptions(
    list,
    ALL_SELECT_LABEL,
    ALL_SELECT_VALUE_STRING,
    'Priority',
    'Priority'
  )

  const sectionOptions = getLookupValueDropDownOption(
    list,
    'Section',
    'MetadataValue',
    ALL_SELECT_LABEL,
    ALL_SELECT_VALUE_STRING,
    'SectionCode'
  )
  const categoryOptions = getLookupValueDropDownOption(
    list,
    'Category',
    'MetadataValue',
    ALL_SELECT_LABEL,
    ALL_SELECT_VALUE_STRING,
    'CategoryCode'
  )
  const subCategoryOptions = getLookupValueDropDownOption(
    list,
    'SubCategory',
    'MetadataValue',
    ALL_SELECT_LABEL,
    ALL_SELECT_VALUE_STRING,
    'SubCategoryCode'
  )
  return {
    categoryOptions,
    organizationOptions,
    priorityOptions,
    sectionOptions,
    subCategoryOptions,
  }
}

export { getInquiryOptions }
